export default {

  setLeftMenuDrawerOpen(payload) {
    this.leftMenuDrawerOpen = payload;
  },

  async switchLeftMenuDrawerState() {
    this.setLeftMenuDrawerOpen(!this.leftMenuDrawerOpen);
  },

  async openLeftMenuDrawer() {
    this.setLeftMenuDrawerOpen(true);
  },

  async closeLeftMenuDrawer() {
    this.setLeftMenuDrawerOpen(false);
  },

  async login() {
  //
  },

  async logout() {
  //
  },

  setEncryptionKeysDialogOpen(payload) {
    this.encryptionKeysDialogOpen = payload;
  },

  setDecryptionKeysDialogOpen(payload) {
    this.decryptionKeysDialogOpen = payload;
  },
};
